<template>
  <div id="base_deposit_withdraw" class="boxCore">
    <div class="transaction">
      <div v-if="type == 'withdraw'">
        <div class="select_transaction_container">
          <div class="tab-header">
            <ul>
              <li :class="{ active: transactionStatus === 'pending' }">
                <a href="javascript:void(0)" @click="selectTab('pending')"
                  ><span>{{ $t("transactions_pending") }}</span></a
                >
              </li>
              <li :class="{ active: transactionStatus === 'history' }">
                <a href="javascript:void(0)" @click="selectTab('history')"
                  ><span>{{ $t("transactions_history") }}</span></a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="filter-container">
        <div class="filter-item date">
          <div class="label-text">{{ $t("orders.open_order.date") }}:</div>
          <date-picker
            :disabled="disabledDatesFrom"
            v-model="startDate"
            class="date-picker-input no-right-radius"
            :format="customFormatter"
          ></date-picker>
          <date-picker
            :disabled="disabledDatesTo"
            v-model="endDate"
            class="date-picker-input no-left-radius"
            :format="customFormatter"
          ></date-picker>
        </div>
        <div class="filter-item pair">
          <div class="label-text">{{ $t("user_wallet.currency") }}:</div>
          <!-- <div class="toolbar-element2">
            <select-box
              v-model="filters.currency"
              :placeholder="$t('order.order_history.all')"
              :options="coins"
            />
          </div> -->
          <CoinInput @onCoinChange="onCoinChange" ref="coinInput" />
        </div>
        <div class="filter-item input_search">
          <input
            title
            type="text"
            :placeholder="$t('orders.open_order.search_by_email')"
            @keyup.enter="search"
            class="form-control input-search"
            name="searchKey"
            v-model.trim="filters.searchKey"
          />
        </div>
        <div class="filter-item btn-action">
          <BaseButton size="medium" @click="search()">{{
            $t("orders.open_order.search")
          }}</BaseButton>
          <BaseButton size="medium" @click="refresh()">{{
            $t("orders.open_order.reset")
          }}</BaseButton>
        </div>
      </div>

      <div class="datatable">
        <data-table
          :getData="getPendingTransactions"
          :limit="10"
          :column="6"
          @DataTable:finish="onDatatableFinish"
          ref="datatable"
          class="scroll"
        >
          <th class="text-left" data-sort-field="CREATED_AT">
            {{ $t("base_deposit_withdraw_title_time") }}
          </th>
          <th class="text-left" data-sort-field="EMAIL">
            {{ $t("base_deposit_withdraw_title_email") }}
          </th>
          <th class="text-left">
            {{ $t("base_deposit_withdraw_title_transactionId") }}
          </th>
          <!-- <th class="text-left" data-sort-field="blockchain_address">Address</th> -->
          <th class="text-left min_w_100px" data-sort-field="CURRENCY">
            {{ $t("base_deposit_withdraw_title_currency") }}
          </th>
          <th class="text-left min_w_120px" data-sort-field="AMOUNT">
            <div>{{ $t("base_deposit_withdraw_title_amount") }}/</div>
            {{ $t("base_deposit_withdraw_title_fee") }}
          </th>
          <th
            v-if="type == 'withdraw' && transactionStatus == 'history'"
            class="text-left min_w_95px"
            data-sort-field="STATUS"
          >
            {{ $t("base_deposit_withdraw_title_status") }}
          </th>
          <th v-else class="text-left min_w_95px">
            {{ $t("base_deposit_withdraw_title_status") }}
          </th>
          <template slot="body" slot-scope="props">
            <tr>
              <td class="text-left custom-time">
                <div>
                  {{ props.item.created_at | timestampToDate }}
                </div>
              </td>
              <td class="text-left">
                <div class="item_email_user">
                  <span class="txt_email_user">{{ props.item.email }}</span>
                  <!-- <span class="tooltip_email_user">{{ props.item.email }}</span> -->
                </div>
              </td>
              <td class="text-left">
                <div class="item_transaction_user">
                  <span class="txt_transaction_user">{{
                    (props.item.is_external === 0
                      ? props.item.transaction_id
                      : props.item.tx_hash) || "-"
                  }}</span>
                  <!-- <span class="tooltip_transaction_user">{{
                    (props.item.is_external === 0
                      ? props.item.transaction_id
                      : props.item.tx_hash) || "-"
                  }}</span> -->
                </div>
              </td>
              <td class="text-left">
                {{ props.item.currency | uppercase }}
              </td>
              <td class="text-left">
                <div>
                  {{
                    getFullAmount(props.item.amount, props.item.fee)
                      | formatBalanceAmount("auto")
                  }}
                </div>
                <div>
                  {{
                    props.item.fee
                      | formatCurrencyAmount(props.item.currency, "auto")
                  }}
                </div>
              </td>
              <td class="text-left">
                {{ props.item.status | uppercaseFirst }}
              </td>
              <!-- <td class="text-left">
                <div
                  v-if="type == 'withdraw' && transactionStatus == 'pending'"
                >
                  <div v-if="!props.item.approved_by" class="btn-wrapper">
                    <BaseButton
                      class="btn btn_Confirm base-button--small"
                      @click="sendTransaction(props.item)"
                      >{{ $t("common.action.send_email") }}</BaseButton
                    >
                    <BaseButton
                      class="btn btn_Reject base-button--small"
                      @click="cancelTransaction(props.item)"
                      >{{ $t("common.action.cancel") }}</BaseButton
                    >
                  </div>
                  <div v-else>{{ props.item.status | uppercaseFirst }}</div>
                </div>
                <div v-else-if="props.item.status === 'error'">
                  {{ "Failed" }}
                </div>
                <div v-else>{{ props.item.status | uppercaseFirst }}</div>
              </td> -->
            </tr>
          </template>
        </data-table>
      </div>
    </div>
    <modal :name="modalName" title="Error Details" :hasModalFooter="false">
      <template slot="body">
        <div class="error-detail">{{ transactionErrorDetail }}</div>
      </template>
    </modal>
    <loading-modal />
  </div>
</template>

<script>
import rf from "../../lib/RequestFactory";
import Modal from "../../components/Modal";
import BigNumber from "bignumber.js";
import DatePicker from "vuejs-datepicker";
import moment from "moment";
import SelectBox from "../../components/SelectBox";
import CoinInput from "../../common/CoinInput.vue";
import BaseButton from "../../common/Button.vue";
import LoadingModal from "@/modals/common/LoadingModal.vue";

export default {
  components: {
    Modal,
    DatePicker,
    SelectBox,
    CoinInput,
    BaseButton,
    LoadingModal,
  },
  props: {
    type: {
      type: String,
      default: "deposit",
    },
  },
  data() {
    return {
      searchKey: "",
      transactionStatus: this.getTransactionStatus(),
      modalName: "DetailErrorModal",
      transactionErrorDetail: "",
      titlePage: window.i18n.t("orders.open_order.open_order"),
      startDate: moment().subtract(6, "days").toDate(),
      endDate: moment().toDate(),
      coin: "",
      filters: {
        currency: "",
        searchKey: "",
        // collect: ""
      },
      coins: [],
      coinMasters: [],
      isShowCoinOption: false,
      trades: [],
      markets: [],
      collectStatus: ["All", "Collected", "Open"],
    };
  },
  watch: {
    transactionStatus() {
      this.resetInput();
      this.$refs.coinInput.refresh();
      this.$refs.datatable.refresh();
    },
  },
  computed: {
    disabledDatesFrom() {
      const disabled = {};
      const today = new Date();
      today.setHours(23, 59, 59, 999); // End of today

      // Disable dates in the future (after today)
      disabled.from = new Date(today.getTime() + 1);

      // If endDate is selected, also disable dates after endDate
      if (this.endDate) {
        const endDateCopy = new Date(this.endDate);
        endDateCopy.setHours(23, 59, 59, 999);

        // Disable from the earlier date between (endDate + 1 day) and (today + 1 day)
        if (endDateCopy < today) {
          disabled.from = new Date(endDateCopy.getTime() + 1);
        }
      }

      return disabled;
    },
    disabledDatesTo() {
      const disabled = {};
      const today = new Date();
      today.setHours(23, 59, 59, 999); // End of today

      // Disable dates in the future (after today)
      disabled.from = new Date(today.getTime() + 1);

      // Disable dates before startDate
      if (this.startDate) {
        const startDateCopy = new Date(this.startDate);
        startDateCopy.setHours(0, 0, 0, 0);
        disabled.to = new Date(startDateCopy.getTime() - 1);
      }

      return disabled;
    },
  },
  methods: {
    getTransactionStatus() {
      return this.type == "deposit" ? "history" : "pending";
    },
    sendTransaction(transaction) {
      let data = {
        transaction_id: transaction.transaction_id,
      };
      ConfirmationModal.show({
        type: "confirm",
        title: window.i18n.t("transactions.withdrawal.send"),
        content: "",
        btnCancelLabel: this.$t("common.action.no"),
        btnConfirmLabel: this.$t("common.action.yes"),
        size: "small",
        onConfirm: () => {
          rf.getRequest("AdminRequest")
            .sendTransaction(data)
            .then((res) => {
              this.$toastr("success", this.$t("common.alert.update.success"));
              this.$refs.datatable.fetch();
            })
            .catch((e) => {
              this.$refs.datatable.refresh();
              if (e.response && e.response.data && e.response.data.message) {
                this.$toastr("error", e.response.data.message);
              }
            });
        },
        onCancel: () => {},
      });
    },

    cancelTransaction(transaction) {
      let data = {
        transaction_id: transaction.transaction_id,
      };
      ConfirmationModal.show({
        type: "confirm",
        title: window.i18n.t("transactions.withdrawal.cancel"),
        content: "",
        btnCancelLabel: this.$t("common.action.no"),
        btnConfirmLabel: this.$t("common.action.yes"),
        size: "small",
        onConfirm: () => {
          rf.getRequest("AdminRequest")
            .cancelTransaction(data)
            .then((res) => {
              this.$toastr("success", this.$t("common.alert.update.success"));
              this.$refs.datatable.fetch();
            })
            .catch((e) => {
              this.$refs.datatable.fetch();
              if (e.response && e.response.data && e.response.data.message) {
                this.$toastr("error", e.response.data.message);
              }
            });
        },
        onCancel: () => {},
      });
    },
    selectTab(tab) {
      this.transactionStatus = tab;
    },
    onCoinChange(currency) {
      this.filters.currency = currency;
    },
    search() {
      let filterParams = {
        start_date: (
          moment(this.startDate).startOf("day").format("x") / 1000
        ).toFixed(0),
        end_date: (
          moment(this.endDate).endOf("day").format("x") / 1000
        ).toFixed(0),
      };
      if (
        this.customFormatter(this.startDate) ===
        this.customFormatter(this.endDate)
      ) {
        filterParams = {
          start_date: (
            moment(this.startDate).startOf("day").format("x") / 1000
          ).toFixed(0),
          end_date: (
            moment(this.startDate).endOf("day").format("x") / 1000
          ).toFixed(0),
        };
      }
      if (
        this.customFormatter(this.startDate) >
        this.customFormatter(this.endDate)
      ) {
        this.$toastr("error", this.$t("common.date.warning"));
        return;
      }
      if (this.filters.searchKey) {
        filterParams.search_key = this.filters.searchKey.trim();
      }
      if (this.filters.currency) {
        filterParams.currency = this.filters.currency.toLowerCase();
      }
      if (this.filters.collect !== "All") {
        filterParams.collect = this.filters.collect;
      }
      this.$refs.datatable.filter(filterParams);
    },
    refresh() {
      this.requestCoinList();
      this.resetInput();
      this.$refs.datatable.refresh();
      this.$refs.coinInput.refresh();
    },
    resetInput() {
      this.filters = Object.assign(this.filters, {
        currency: "",
        searchKey: "",
        collect: "",
      });
      this.startDate = moment().subtract(6, "days").toDate();
      this.endDate = moment().toDate();
    },
    /*
      getMarkets() {
        return window._.map(COMMON_CONST.MARKETS, item => {
          return { id: item, name: item.toUpperCase() };
        });
      },
      */

    getPendingTransactions(params) {
      this.$modal.show("modal-loading");

      const meta = {
        type: this.type,
        status: this.type === "deposit" ? "success" : this.transactionStatus,
        start_date: (
          moment(this.startDate).startOf("day").format("x") / 1000
        ).toFixed(0),
        end_date: (
          moment(this.endDate).endOf("day").format("x") / 1000
        ).toFixed(0),
      };
      if (!window._.isEmpty(this.searchKey)) {
        meta.search_key = this.searchKey;
      }

      let paramRefactor = undefined;
      params = Object.assign(params, meta);

      if (params.sort_type) {
        params.sort_type = params.sort_type.toUpperCase();
      } else {
        delete params.sort_type;
      }

      if (
        params.type === "withdraw" &&
        params.sort === "AMOUNT" &&
        params.sort_type
      ) {
        // amount is a Negative number
        paramRefactor = Object.assign(params, {
          sort_type: params.sort_type === "ASC" ? "DESC" : "ASC",
        });
      } else {
        paramRefactor = params;
      }
      return rf
        .getRequest("AdminRequest")
        .getTransactions(paramRefactor)
        .finally(() => {
          this.$modal.hide("modal-loading");
        });
    },

    onDatatableFinish() {
      const datatable = this.$refs.datatable;
      // Only sort 'amount' field a again. Because amount field can be negative (withdraw) or positive (deposit).
      if (datatable.params.sort !== "AMOUNT") {
        return;
      }
      const result = window._.chain(datatable.rows)
        .map((item) => {
          item.amount = Math.abs(parseFloat(item.amount));
          return item.toUpperCase();
        })
        .value();

      this.$refs.datatable.rows = result.toUpperCase();
    },

    // Get amount which hasn't calculate fee yet.
    getFullAmount(reductionAmount, fee) {
      return new BigNumber(`${Math.abs(reductionAmount)}`)
        .add(`${fee}`)
        .toString();
    },
    formatDateTime(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
    },
    customFormatter(date) {
      return moment(date).format("YYYY - MM - DD");
    },
    // onSearchCoin() {
    //   try {
    //     this.coins = _.filter(this.coinMasters, (item) => {
    //       return _.isMatch(item.toUpperCase(), this.filters.currency.toUpperCase());
    //     });
    //   }
    //   catch(e) {
    //     console.log(e);
    //   }
    // },
    // showCoinOption() {
    //   this.isShowCoinOption = !this.isShowCoinOption;
    //   this.coins = this.coinMasters && this.coinMasters.map(x => x.toUpperCase());
    // },
    requestCoinList() {
      rf.getRequest("CoinSettingRequest")
        .getCoinList()
        .then((res) => {
          if (window._.map(res.data, "coin")) {
            this.coinMasters = window._.map(res.data, "coin");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // onSelectCoin(coin) {
    //   this.isShowCoinOption = false;
    //   this.filters.currency = coin;
    // },
    // clickOut() {
    //   this.isShowCoinOption = false;
    // },
  },
  created() {
    this.requestCoinList();
    rf.getRequest("AdminRequest")
      .getPriceGroupCurrency()
      .then((res) => {
        try {
          window._.map(res.data, (item) => {
            if (typeof item.currency !== "undefined") {
              this.markets.push({
                id: item.currency,
                name: item.currency.toUpperCase(),
              });
            }
          });
        } catch (ex) {
          console.error(ex);
        }
      });
  },
  mounted() {
    this.$modal.show("modal-loading");
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/variables";
// @media only screen and (max-width: 1380px) {
//   table {
//       thead {
//         th {
//           padding: 0px 10px !important;
//         }
//       }
//     }
// }
// @media only screen and (max-width: 1725px){
//   .deposit_pages .btn_Reject{
//       // margin-top: 5px;
//       margin-left: 0 !important;
//   }
// }

#base_deposit_withdraw {
  @media only screen and (max-width: 1380px) {
    table {
      // min-width: 1380px;
      thead {
        th {
          padding: 0px 10px !important;
        }
      }
    }
  }
  @media only screen and (max-width: 1725px) {
    .deposit_pages .btn_Reject {
      margin-top: 5px;
      margin-left: 0 !important;
    }
  }

  .filter-container {
    display: block;
    float: left;
    width: 100%;
    margin: 5px 0px 30px 0px;
    .filter-item {
      display: inline-block;
      float: left;
      margin: 0 0 0 0;
      margin-right: 20px;
      .label-text {
        line-height: 15px;
        margin-bottom: 7px;
        color: $color-grey-dusty;
        font-size: $font-small;
        padding: 0 0 0 0;
      }
      .text-pair {
        padding-left: 16px;
      }
      &.date {
        min-width: 222px;
        .date-picker-input {
          input {
            width: 135px !important;
            display: block;
            background-size: 12px 12px;
            padding: 8px 0px 7px 30px;
            background-position: center left 8px;
          }
        }
      }
      &.pair {
        min-width: 65px;
        .coin-inputt.toolbar-element22 {
          input {
            padding: 8px 5px 7px 11px;
            margin: 0 0 0 0;
            width: 100%;
          }
          .coin-option {
            left: 0px;
          }
          .icon-coin-input {
            i {
              font-size: 16px;
              color: $color-grey-dusty;
            }
          }
        }
      }
      &.input_search {
        width: 255px;
        margin-right: 10px;
        input {
          margin: 22px 0 0 0;
          padding: 8px 16px 7px 16px;
          color: $color-grey-dusty;
          font-size: $font-small;
          font-family: $mulish-regular;
          height: 30px;
          background-color: transparent;
        }
      }
      &.btn-action {
        display: flex;
        gap: 10px;
        margin-top: 23px;
        max-height: 30px;
        button {
          font-size: 12px;
        }
      }
    }
  }
  .select_transaction_container {
    display: block;
    width: 100%;
    float: left;
    margin: 10px 0px 15px 0px;
    ul {
      display: block;
      width: 100%;
      float: left;
      padding: 0 0 0 0;
      li {
        float: left;
        margin-right: 25px;
        font-size: 18px;
        color: $color-grey-dark;
        display: block;
        a {
          color: $color-grey-dark;
          font-family: $mulish-regular, sans-serif;
          font-weight: 500;
          font-size: $font_big;
          display: block;
          float: right;
          &:before {
            content: "";
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            border: solid 1px #979797;
            margin-right: 3px;
          }
        }
        &.active {
          a {
            color: $color-jungle-green;
            &:before {
              border: solid 4px $color-jungle-green;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import "@/assets/sass/variables";
.min_w_100px {
  min-width: 100px;
}
.min_w_120px {
  min-width: 120px;
}
.min_w_95px {
  min-width: 95px;
}
#base_deposit_withdraw {
  .sc_search_select {
    .group_search_select {
      .button_drop_search {
        width: 92px;
        height: 30px !important;
        padding: 7px 10px 5px 10px !important;
        border-radius: 3px;
        margin-right: 20px;
        font-size: $font-small;
        font-family: $mulish-regular;
        i.icon-arrow1 {
          margin-left: 5px;
          color: $color_dove_gray;
        }
        &:hover {
          border-color: $color-jungle-green;
          i.icon-arrow1 {
            color: $color-jungle-green;
          }
        }
      }
      .box_list_search_select {
        .list_search_select {
          li {
            font-family: $mulish-regular;
            font-size: $font-small;
            &:hover,
            &:active,
            &:focus {
              color: $color-jungle-green;
            }
          }
        }
      }
    }
  }

  .btn-wrapper {
    display: flex;
  }
  .btn_Reject {
    margin-left: 10px;
  }
  @media (max-width: 1280px) {
    .btn_Reject {
      margin-top: 5px;
      margin-left: 0px !important;
    }
  }
}
#deposit_pages,
#withdrawal_pages {
  td {
    padding-right: 10px;
  }
  @media (max-width: 1280px) {
    .btn_Reject {
      margin-top: 0;
    }
  }
  @media only screen and (max-width: 1380px) {
    table {
      thead {
        th {
          padding-left: 15px !important;
        }
      }
    }
  }
  @media only screen and (max-width: 1725px) {
    .deposit_pages .btn_Reject {
      margin-top: 0;
    }
  }
}
.custom-time {
  min-width: 120px;
}
.item_email_user {
  display: inline-block;
  float: left;
  position: relative;
  .txt_email_user {
    display: block;
    max-width: 255px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tooltip_email_user {
    position: absolute;
    top: 0px;
    left: 0px;
    line-height: 20px;
    padding: 5px 20px;
    left: 100%;
    background-color: $color_white;
    white-space: nowrap;
    width: auto;
    z-index: 10;
    font-size: $font_root;
    font-weight: 500;
    color: $color_mine_shaft;
    transition: 0.5s;
    display: none;
    box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
    &:after {
      right: 100%;
      top: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-right-color: $color_white;
      border-width: 5px;
      margin-top: -5px;
    }
  }
  &:hover {
    .tooltip_email_user {
      display: block;
      transition: 0.5s;
    }
  }
}

.item_transaction_user {
  display: inline-block;
  float: left;
  position: relative;
  .txt_transaction_user {
    display: block;
    max-width: 550px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tooltip_transaction_user {
    position: absolute;
    top: 0px;
    left: 0px;
    line-height: 20px;
    padding: 5px 20px;
    left: 100%;
    background-color: $color_white;
    white-space: nowrap;
    width: auto;
    z-index: 10;
    font-size: $font_root;
    font-weight: 500;
    color: $color_mine_shaft;
    transition: 0.5s;
    display: none;
    box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
    &:after {
      right: 100%;
      top: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-right-color: $color_white;
      border-width: 5px;
      margin-top: -5px;
    }
  }
  &:hover {
    .tooltip_transaction_user {
      display: block;
      transition: 0.5s;
    }
  }
}
</style>
